<mat-card>
    <mat-card-header>
        <div mat-card-avatar *ngIf="icon"><fa-icon [icon]="icon" size="3x"></fa-icon></div>
        <mat-card-title>{{title}}</mat-card-title>
        <mat-card-subtitle *ngIf="subTitle">{{subTitle}}</mat-card-subtitle>
    </mat-card-header>
    <mat-progress-bar [mode]="progress >= 100 ? 'indeterminate' : 'determinate'" [value]="progress"></mat-progress-bar>
</mat-card>
